<script>
    import API from "../../services/api.svelte.js";
    import { notificate } from "../../services/notification.js";
    import { goto, params } from "@roxi/routify";
    import { format, locale } from "svelte-i18n";
    import { removeTags } from "../../js/utils.js";

    $goto; // manually initialize the helper
    const redirect = (path) => $goto(path);

    let loading = $state(false);
    let register_success = $state(false);
    let show_submit_btn = $state(true);
    let blocked_email_domain_error = $state(false);
    let blocked_email_spam = false;
    let user_exists = $state(false);
    let blocked_ip_error = $state(false);

    let formData = $state({
        name: $params.name ? removeTags($params.name) : null,
        organization: $params.organization
            ? removeTags($params.organization)
            : null,
        email: $params.email ? removeTags($params.email) : null,
        position: $params.promo_code ? removeTags($params.promo_code) : null,
        language: $params.language ? removeTags($params.language) : "",
        plan: $params.plan ? removeTags($params.plan) : "",
    });
    const clearFormData = () => {
        return (formData = {
            name: null,
            organization: null,
            email: null,
            position: null,
            language: "",
            plan: "",
        });
    };

    const updateSubmitBtnVar = () => {
        show_submit_btn = !show_submit_btn;
    };

    const signUp = async (formData = {}) => {
        loading = true;
        blocked_email_domain_error = false;
        blocked_email_spam = false;
        user_exists = false;
        if (formHasErrors(formData)) {
            loading = false;
            return;
        }

        API.signUp("signup", formData).then(async (response) => {
            if (response.status == 200) {
                register_success = true;
                loading = false;
                updateSubmitBtnVar();
                redirect("/register_request_success");
            }
            if (!response.ok) {
                let errors = await response.json();
                if (errors.detail && typeof errors.detail == "string") {
                    if (errors.detail.includes("email_already_exists")) {
                        clearFormData();
                        user_exists = true;
                    }
                    if (errors.detail.includes("blocked_email_domain")) {
                        clearFormData();
                        blocked_email_domain_error = true;
                    }
                    if (errors.detail.includes("ip_address_recently_used")) {
                        clearFormData();
                        blocked_ip_error = true;
                    }
                    updateSubmitBtnVar();
                    clearFormData();
                }
                if (errors.detail && typeof errors.detail == "object") {
                    if (errors.detail[0].includes("email_already_exists")) {
                        clearFormData();
                        user_exists = true;
                    }
                    if (errors.detail[0].includes("blocked_email_domain")) {
                        clearFormData();
                        blocked_email_domain_error = true;
                    }
                    if (errors.detail[0].includes("ip_address_recently_used")) {
                        clearFormData();
                        blocked_ip_error = true;
                    }
                    updateSubmitBtnVar();
                    clearFormData();
                }
            }
        });
        loading = false;
        updateSubmitBtnVar();
        //clearFormData();
    };

    /*
        Form validation func (all fields required + valid email validation withr regex
        @param formData
        @returns true (has errors) | false (no errors)

    */
    const formHasErrors = (formData) => {
        if (
            !formData.name ||
            !formData.organization ||
            !formData.email ||
            emailValidation(formData.email).error ||
            !formData.language ||
            formData.language == "" ||
            !formData.plan ||
            formData.plan == ""
        ) {
            loading = false;
            notificate("422");
            return true;
        } else {
            return false;
        }
    };

    /*
        Email validation func
        @param email string
        @returns false | error (string)
    */
    const emailValidation = (email) => {
        const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(email)) {
            return { error: $format("page.register.insert_valid_email") };
        } else {
            return { error: false };
        }
    };
</script>

<section class="content vw-100">
    <div class="col-xl-7 col-12 float-start landing-list-container">
        <div class="mt-xl-5">
            <ul class="landing-list">
                <li class="mb-3 mt-5 d-flex">
                    <img src="/img/landing-icono1.svg" alt="" /><span
                        >{$format("page.register.total_access")}</span
                    >
                </li>
                <li class="mb-3 d-flex">
                    <img src="/img/landing-icono2.svg" alt="" /><span
                        >{$format("page.register.start_scanning")}</span
                    >
                </li>
                <li class="mb-3 d-flex">
                    <img src="/img/landing-icono3.svg" alt="" /><span
                        >{$format("page.register.detect")}</span
                    >
                </li>
                {#if $locale == "es"}
                    <li class="d-flex">
                        <img src="/img/landing-icono4.svg" alt="" /><span
                            >Recibí informes <br /> completamente en español</span
                        >
                    </li>
                {/if}
            </ul>
            <img
                class="logo"
                src="/img/landing-logo-vulseek.svg"
                alt="Vulseek by Securetia"
            />
        </div>
    </div>
    <div class="col-xl-5 col-12 float-end landing-page-form-container">
        {#if loading}
            <div class="overlay text-center">
                <i class="fas fa-2x fa-sync-alt fa-spin mt-3"></i>
            </div>
        {:else if !register_success}
            <h4 class="text-start">{$format("page.register.title")}</h4>
            <p class="mt-3" style="text-align: left;">
                {@html $format("page.register.scan")}
            </p>
            <form>
                <div class="mb-3 d-flex">
                    <div>
                        <input
                            bind:value={formData.name}
                            type="text"
                            class="form-control"
                            id="name"
                            placeholder={$format("page.register.name_surname")}
                        />
                        <label for="name"
                            >{$format("page.register.name_surname")}
                            <span class="vlsk-red">*</span></label
                        >
                    </div>
                </div>

                <div class="mb-3 d-flex">
                    <div>
                        <input
                            bind:value={formData.organization}
                            type="text"
                            class="form-control"
                            id="organization"
                            placeholder={$format("page.register.company")}
                        />
                        <label for="organization"
                            >{$format("page.register.company")}
                            <span class="vlsk-red">*</span></label
                        >
                    </div>
                </div>
                <div class="mb-3 d-flex">
                    <div>
                        <input
                            bind:value={formData.email}
                            type="email"
                            class="form-control"
                            id="email"
                            placeholder="xxxxxxxxx@email.com"
                        />
                        <label for="email"
                            >{$format("page.register.email")}<span
                                class="vlsk-red">*</span
                            ></label
                        >
                        {#if formData.email && emailValidation(formData.email).error}<small
                                class="text-danger"
                                >{emailValidation(formData.email).error}</small
                            >{/if}
                    </div>
                </div>
                <div class="mb-3 d-flex">
                    <div>
                        <input
                            bind:value={formData.position}
                            type="text"
                            class="form-control"
                            id="position"
                            placeholder={$format("page.register.promo")}
                        />
                        <label for="position"
                            >{$format("page.register.promo")}</label
                        >
                    </div>
                </div>
                <div class="mb-3 d-flex">
                    <div>
                        <select
                            bind:value={formData.language}
                            class="form-control"
                            id="lang"
                        >
                            <option value="" selected="selected"
                                >{$format("form.fields.select")}</option
                            >
                            <option value="en">{$format("english")}</option>
                            <option value="es">{$format("spanish")}</option>
                        </select>
                        <label for="lang"
                            >{$format("page.register.lang")}
                            <span class="vlsk-red">*</span></label
                        >
                    </div>
                </div>

                <div class="mb-3 d-flex">
                    <div>
                        <select
                            bind:value={formData.plan}
                            class="form-control"
                            id="lang"
                        >
                            <option value="" selected="selected"
                                >{$format("form.fields.select")}</option
                            >
                            <option value="free">Free</option>
                            <option value="starter">Starter</option>
                            <option value="standard">Standard</option>
                            <option value="premium">Red Team Operations</option>
                        </select>
                        <label for="lang"
                            >Plan <span class="vlsk-red">*</span></label
                        >
                        <small
                            >{$format("page.register.plan_info")}:
                            <a
                                href={$locale == "es"
                                    ? "https://www.securetia.com/vulseek.html"
                                    : `https://www.securetia.com/${$locale}/vulseek.html`}
                                target="_blank"
                                >{$locale == "es"
                                    ? "https://www.securetia.com/vulseek.html"
                                    : `https://www.securetia/${$locale}/vulseek.html`}</a
                            ></small
                        >
                    </div>
                </div>

                <div class="text-start mt-3">
                    <span class="vlsk-red">*</span><small
                        >{$format("required")}</small
                    >
                </div>
                <div class="text-start mt-3">
                    <small>{$format("page.register.accept_comms")}</small>
                </div>
                {#if blocked_email_domain_error}
                    <div class="text-start mt-3 text-danger">
                        {$format("page.register.company_mail")}
                    </div>
                {/if}
                {#if blocked_ip_error}
                    <div class="text-start mt-3 text-danger">
                        {@html $format("page.register.too_many_requests")}
                    </div>
                {/if}
                {#if user_exists}
                    <div class="text-start mt-3 text-danger">
                        {$format("page.register.mail_exists")}
                    </div>
                {/if}
            </form>
        {:else}
            <div class="pt-5 pb-5" style="text-align: center;">
                {$format("page.register.request_success")}
            </div>
        {/if}
        {#if !register_success}
            {#if show_submit_btn}
                <button
                    type="button"
                    class="mt-3 btn btn-default"
                    style="color: white;"
                    onclick={() => signUp(formData)}
                    >{$format("buttons.send")}</button
                >
            {:else}
                <div class="overlay text-center mt-3">
                    <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                </div>
            {/if}
        {/if}
    </div>
</section>

<style>
    .content {
        height: 100%;
        overflow: hidden;
    }

    .landing-list-container {
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        justify-content: center;
        height: 12vh;
    }

    .d-flex > div {
        flex: 1;
        text-align: left;
    }

    label {
        font-size: 0.875rem;
        color: #333333;
        text-align: left;
        display: inline-block;
        width: 100%;
        font-weight: lighter;
    }

    h4,
    p {
        color: #1a1a1a;
    }

    .btn.btn-default:hover {
        opacity: 0.8;
    }

    input:focus {
        background-color: transparent;
    }

    h4 {
        font-size: 1.25rem;
        margin-bottom: 0 !important;
        /*margin-top: -3.5em;*/
        font-weight: bold;
    }

    input {
        background: transparent;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom-color: #333333;
        border-radius: 0;
        padding-left: 0 !important;
        color: #333 !important;
    }

    input::placeholder {
        color: #333 !important; /* Replace with your color */
        opacity: 1; /* Required for Firefox */
    }

    select {
        color: #333 !important;
    }

    input:hover,
    input:focus,
    input:active,
    select:hover,
    select:focus,
    select:active {
        border-color: #fb383b !important;
    }

    input:hover + label,
    input:focus + label,
    input:active + label,
    select:hover + label,
    select:focus + label,
    select:active + label {
        color: #fb383b !important;
    }

    .btn.btn-default {
        background: #333333;
        border-color: #333333;
        /*padding-left: 2rem;
        padding-right: 2rem;
        margin-left: -69px;*/
        width: 100%;
    }

    p {
        font-size: 0.75rem;
        line-height: 1;
    }

    .landing-list {
        display: none;
    }

    .logo {
        width: 150px;
        display: block;
    }
    .landing-page-form-container {
        background: #ccc;
        height: 88vh;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: flex-start;
        padding: 1.5em 3em;
        overflow-y: scroll;
        color: #333 !important;
    }

    input {
        background-color: transparent !important;
        border: 1px solid #333333;
        box-shadow: none !important;
        border-top: none !important;
        border-right: none !important;
        border-left: none !important;
    }

    select {
        background-color: transparent !important;
        border: 1px solid #333333;
        box-shadow: none !important;
    }

    @media (min-width: 1200px) {
        h4 {
            font-size: 2rem;
            padding-right: 2em;
            margin-bottom: 0 !important;
            margin-top: 0;
        }

        label {
            font-size: 1.25rem;
            color: #333333;
            text-align: left;
            display: inline-block;
            width: 100%;
        }

        p {
            font-size: 1.5rem;
        }

        .landing-list-container {
            height: 100vh;
            display: flex;
            flex-direction: column;
            align-content: center;
            justify-content: center;
            align-items: center;
        }

        .landing-list {
            display: block;
            color: white;
            font-size: 1.5rem;
            list-style: none;
            margin-top: 5em;
            padding-left: 0;
            /*margin-left: -1em;*/
            margin-bottom: 2em;
            margin-left: 6em;
        }

        .landing-list li img {
            width: 50px;
            margin-right: 15px;
        }

        .landing-list li span {
            max-width: 70%;
            margin-right: 15px;
            display: inline-block;
            align-self: center;
        }

        .logo {
            width: 200px;
            display: block;
            /*margin-left: -1.25em;*/
            margin-left: 10.1em;
        }
        .landing-page-form-container {
            background: #ccc;
            height: 100vh;
            min-height: 100%;
            display: flex;
            flex-direction: column;
            align-content: center;
            justify-content: center;
            padding: 0 4em;
        }
    }

    @media (min-width: 1376px) {
        h4 {
            font-size: 2rem;
        }
        .landing-page-form-container {
            padding: 0 6em;
        }
    }

    @media (min-width: 1450px) {
        .logo {
            margin-left: 9em;
        }
        h4 {
            font-size: 2rem;
        }
        p {
            font-size: 1.25rem;
        }
    }

    @media (min-width: 1750px) {
        h4 {
            font-size: 2.25rem;
        }
    }

    @media (min-width: 1830px) {
        h4 {
            font-size: 2.5rem;
        }
        .landing-page-form-container {
            padding: 0 8em;
        }
    }
</style>
